import React, { useMemo, Fragment } from 'react';
import { uniqBy } from 'lodash';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';

import styles from './index.module.scss';
import './social-icons.scss';

/** @param {string} platform  */
const prettifyName = (platform) => platform.replace(/_/g, '/');

/** @type {React.FC<{professionalPresences: import('../../../../types').SocialPlatform[], onlinePresences: import('../../../../types').SocialPlatform[]}>} */
const SocialPresence = ({ professionalPresences = [], onlinePresences = [] }) => {
    const platforms = useMemo(
        () =>
            uniqBy([...professionalPresences, ...onlinePresences], 'platform').map((elem) =>
                elem.platform.toLowerCase()
            ),
        [onlinePresences, professionalPresences]
    );

    if (!platforms.length) {
        return null;
    }

    const itemClassNames = classnames(styles.platformName, 'text-capitalize m-l-12');

    return (
        <Fragment>
            <div className={'text-semi-bold m-b-16'}>
                <I18n k={'freelancer_page.details.social_presence'} />
            </div>
            <div className={classnames('flex flex-col platform-icons-list', styles.platformsList)}>
                {platforms.map((platform) => (
                    <div key={platform} className="flex flex-items-center">
                        <i className={`platform-icon ${platform}`} aria-hidden="true" />
                        <span className={itemClassNames}>{prettifyName(platform)}</span>
                    </div>
                ))}
            </div>
        </Fragment>
    );
};

export default SocialPresence;
